import { ITrackProject } from "rules/interface/project/track.interface";

class trackProjectService {
    get(): ITrackProject[] {
        return typeof window !== "undefined" && (JSON.parse(localStorage.getItem("track")) ?? []);
    }
    setTrack(track: ITrackProject) {
        if (typeof window !== "undefined") {
            let tracked = this.get()

            if (track.timeSpent > 7) {
                tracked[tracked.length - 1].timeSpent = track?.timeSpent ?? 1
            }
            else tracked.push(track)

            localStorage.setItem("track", JSON.stringify(tracked))
        }
    }
}
export default new trackProjectService();